import { render } from "./pos-permissions.vue?vue&type=template&id=43d44fd4"
import script from "./pos-permissions.vue?vue&type=script&lang=js"
export * from "./pos-permissions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__